import { useLocation } from 'react-router'

import { matchesPaths } from '@/lib/helpers/routeHelpers'

export function useIsRoute() {
  const { pathname } = useLocation()

  return function (route: string, testPath?: string) {
    const finalTestPath = testPath !== undefined ? testPath : pathname

    return matchesPaths(finalTestPath, [route])
  }
}
